import { render, staticRenderFns } from "./ClubCard.vue?vue&type=template&id=0482f8da&scoped=true&"
import script from "./ClubCard.vue?vue&type=script&lang=js&"
export * from "./ClubCard.vue?vue&type=script&lang=js&"
import style0 from "./ClubCard.vue?vue&type=style&index=0&id=0482f8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0482f8da",
  null
  
)

export default component.exports